import { defaultStatusCodeCheck, extractBody, logDefaultServerError, sanitiseInput, singleton, } from '@sky-uk-ott/client-lib-js-ott-utils';
import { tokenizeRequest } from '../../utils/request-utils';
import { consolidatedStreamStartPrefetchRequest } from './device-manager-request';
var SANITISE_INPUTS = [
    {
        match: /(dcm\/devices\/)(.*)/,
        replacement: '$1{deviceId}',
    },
];
var DeviceManagerService = /** @class */ (function () {
    function DeviceManagerService(ottHeaders, _a) {
        var endpoints = _a.endpoints, timeouts = _a.timeouts, request = _a.request, ovpTokenService = _a.ovpTokenService, logger = _a.logger;
        var bakeRequest = function (requestParamsCreator) {
            return tokenizeRequest(request, ovpTokenService, ottHeaders, requestParamsCreator, endpoints.dcm.hostname, endpoints.dcm.path, timeouts, logger);
        };
        this.configuredConsolidatedStartStreamPrefetchRequest = bakeRequest(consolidatedStreamStartPrefetchRequest);
        this.logger = logger;
    }
    DeviceManagerService.prototype.consolidatedStartStreamPrefetch = function (prePlayoutId, metadataToken, streamSourceType, asset) {
        var _this = this;
        return this.configuredConsolidatedStartStreamPrefetchRequest(prePlayoutId, metadataToken, streamSourceType, asset)
            .then(function (data) {
            return logDefaultServerError(data, 'OVP - DeviceManagementService', _this.logger, sanitiseInput(SANITISE_INPUTS));
        })
            .then(defaultStatusCodeCheck)
            .then(extractBody);
    };
    return DeviceManagerService;
}());
export { DeviceManagerService };
export default singleton(DeviceManagerService);
//# sourceMappingURL=device-manager-service.js.map